import type { Patient } from "@louise/medical-history/basic-info/calculateBasicInfoCompletion";

export function calculateDiseaseHistoryCompletion(
  patient: Patient | null | undefined,
) {
  const medicalHistory = (patient as any)?.medicalHistory;
  const isAMAB = (patient as any)?.gender === "AMAB";

  const hasBreastTestings =
    medicalHistory?.hasBreastTestings !== undefined &&
    medicalHistory?.hasBreastTestings !== null;

  const hasBreastConditions =
    medicalHistory?.hasBreastConditions !== undefined &&
    medicalHistory?.hasBreastConditions !== null;

  // Disease categories: at least one category flag answered
  const categoryFlags = [
    "hasEndocrineDiseases",
    "hasInfectiousDiseases",
    "hasCardiovascularDiseases",
    "hasRespiratoryDiseases",
    "hasGastrointestinalDiseases",
    "hasHepaticBiliaryDiseases",
    "hasRenalUrinaryDiseases",
    "hasMusculoskeletalDiseases",
    "hasHaematologicalDiseases",
    "hasAutoimmuneDiseases",
    "hasGeneticDiseases",
    "hasEatingDisorders",
    "hasNeurologicalMentalHealthDiseases",
  ];

  const hasDiseaseCategories = categoryFlags.some(
    (flag) =>
      medicalHistory?.[flag] !== undefined && medicalHistory?.[flag] !== null,
  );

  const hasCancerHistory =
    medicalHistory?.hasCancerHistory !== undefined &&
    medicalHistory?.hasCancerHistory !== null;

  // AMAB users skip breast testing/conditions
  const fields = isAMAB
    ? [hasDiseaseCategories, hasCancerHistory]
    : [hasBreastTestings, hasBreastConditions, hasDiseaseCategories, hasCancerHistory];
  const completed = fields.filter(Boolean).length;
  const total = fields.length;
  const percent = total > 0 ? completed / total : 0;
  const label = `${completed}/${total} answered`;

  return { percent, label, completed, total };
}
